import 'jquery-ui-dist/jquery-ui'
import $ from 'jquery'
import jsPDF from "jspdf"
import { useState } from 'react'
import { showErrorStrToast } from '../../ui'
import { printPdfBlob } from "../utils/printUtils"

export const usePDFActions = () => {
    const [isPrinting, setIsPrinting] = useState(false)

    const generatePDFBlob = (pdfId: string): Promise<Blob> => {
        return new Promise<Blob>((resolve, reject) => {
            const doc = new jsPDF('portrait', 'px', [595, 842])
            const element = document.getElementById(pdfId)
            if (!element) {
                reject(new Error('Elemento PDF no encontrado'))
                return
            }
            const clone = element.cloneNode(true) as HTMLElement
            $(clone).css('display', 'block')
            doc.html(clone, {
                callback: () => {
                    resolve(doc.output('blob'))
                }
            })
        })
    }

    const generatePDF = (
        pdfId: string,
        fileName: string,
    ) => {
        const doc = new jsPDF('portrait', 'px',[595, 842])
        const element = document.getElementById(pdfId)
        if (element) {
            const clone = element.cloneNode(true) as HTMLElement
            $(clone).css('display', 'block')
            doc.html(clone, {
                callback: () => {
                    doc.save(fileName)
                }
            })
        }
    }

    const printPDF = async (pdfId: string): Promise<void> => {
        try {
            setIsPrinting(true)
            const blob = await generatePDFBlob(pdfId)
            await printPdfBlob(blob)
        } catch {
            showErrorStrToast('Error al generar el PDF para imprimir.')
        } finally {
            setIsPrinting(false)
        }
    }

    return {
        generatePDF,
        generatePDFBlob,
        printPDF,
        isPrinting
    }
}
